import { render, staticRenderFns } from "./NotificationTemplatesListModal.vue?vue&type=template&id=6b701142&scoped=true&"
import script from "./NotificationTemplatesListModal.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplatesListModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplatesListModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationTemplatesListModal.vue?vue&type=style&index=1&id=6b701142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b701142",
  null
  
)

export default component.exports